import {
  ClerkProvider as BaseClerkProvider,
  useAuth,
} from '@clerk/clerk-react';
import { useEffect } from 'react';
import { setTRPCTokenGetter } from '@/shared/api/trpc';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const DEV_BYPASS_AUTH = import.meta.env.VITE_DEV_BYPASS_AUTH === 'true';

const AuthTokenSync = ({ children }: { children: React.ReactNode }) => {
  const { getToken } = useAuth();

  useEffect(() => {
    if (DEV_BYPASS_AUTH) return;
    setTRPCTokenGetter(() => getToken());
  }, [getToken]);

  return children;
};

type ClerkProviderProps = {
  children: React.ReactNode;
};

export const ClerkProvider = ({ children }: ClerkProviderProps) => (
  <BaseClerkProvider publishableKey={PUBLISHABLE_KEY}>
    <AuthTokenSync>{children}</AuthTokenSync>
  </BaseClerkProvider>
);
